import React from 'react';
import { observer } from "mobx-react-lite";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import "./RankedUsers.scss";
import { StateService } from "../services/StateService";
import { InfoBox } from './InfoBox';

interface RankedUsersProps {
  state: StateService;
  selected_round: string;
}

export const RankedUsers = observer((props: RankedUsersProps) => {

  const list = props.state.userVotes
    .getVotes(props.selected_round)
    .map(([address, submitted], i) => {
      return (
        <div key={i} className="col-md-12 mb-3">
          <div className="userStatusBox">
            <div className="userImgName me-1">
              {address === (props.state.authentication.getAddress() || "") && (
                <span className="me">Me</span>
              )}
              <span className="text-white mb-0">{address}</span>
            </div>
            {submitted && (
              <div className="userStatus">
                <CheckCircleIcon
                  style={{ color: "#7AB169", fontSize: 29 }}
                />
              </div>
            )}
            {!submitted && (
              <div className="userStatus">
                <RemoveCircleIcon
                  style={{ color: "#E8B853", fontSize: 29 }}
                />
              </div>
            )}
          </div>
        </div>
      );
    });

  return (
    <div className="col-12 col-lg-3 col-md-4 main-ranking-users-section">
      <div className="row">
      <div className="col-md-12">
      <div className="status-title">
        <h2 className="secTitle ms-2 statusTitle">Voting Status</h2>
        <InfoBox
          title="This table shows who has voted in this round."
        />
      </div>
      </div>
      </div>
      <div className="row">{list}</div>
    </div>
  );
});
